
import { useState, useRef } from 'react';
import logo from './logo.png'
import logo_poziom from './logo_poziom.png'
import mini_lock from './mini_lock.png'
import Config from './Config';
import InputUsername from './helpers/InputUsername';
import InputPassword from './helpers/InputPassword';
import InputPhone from './helpers/InputPhone';
import InputEmail from './helpers/InputEmail';
import InputInteger from './helpers/InputInteger';
import InputText from './helpers/InputText';


// Delikatny, symboliczny akcent aktualnej pory roku (śnieg / kwiaty / liście / pyłki światła).
function getCurrentSeason() {
    var m = new Date().getMonth(); // 0 = styczeń

    if(m == 11 || m == 0 || m == 1) return 'winter';
    if(m >= 2 && m <= 4) return 'spring';
    if(m >= 5 && m <= 7) return 'summer';
    return 'autumn';
}

// Deterministyczne (nielosowe) parametry cząsteczek - dzięki temu animacja nie
// "przeskakuje" przy każdym renderze (np. podczas ruchu myszą nad kartą logowania).
function buildSeasonParticles() {
    var count = 12;
    var particles = [];

    for(var i = 0; i < count; i++)
    {
        particles.push({
            left: ((i * 8.3) + (i % 4) * 6) % 100,
            delay: (i * 0.9) % 11,
            duration: 11 + (i % 5) * 2.4,
            scale: 0.6 + (i % 4) * 0.18,
            drift: (i % 2 == 0 ? 1 : -1) * (12 + (i % 3) * 8),
        });
    }

    return particles;
}


// Wspólna "obudowa" ekranu logowania: tło z animowanymi blobami, szklana karta
// z efektem 3D (tilt) reagującym na kursor myszy (tylko na desktopie) oraz stopka.
// Wydzielona jako osobny, zewnętrzny komponent - dzięki temu przy każdym renderze
// LoginForm nie tworzy nowego typu komponentu (co powodowałoby remount i utratę
// fokusu w polach formularza).
function LoginShell({ cardRef, tilt, isTilting, onCardMouseMove, onCardMouseLeave, footer, children })
{
    var season = getCurrentSeason();
    var particles = buildSeasonParticles();

    return (
        <div className='elizak login_page'>

            <div className='blob blob_a'></div>
            <div className='blob blob_b'></div>
            <div className='blob blob_c'></div>
            <div className='grid_overlay'></div>

            {/* Delikatny akcent aktualnej pory roku (śnieg / kwiaty / liście / światło lata). */}
            <div className={'login_season season_' + season} aria-hidden="true">
                {particles.map((p, i) => (
                    <span
                        key={i}
                        className='season_particle'
                        style={{
                            '--left': p.left + '%',
                            '--delay': p.delay + 's',
                            '--duration': p.duration + 's',
                            '--scale': p.scale,
                            '--drift': p.drift + 'px',
                        }}
                    ></span>
                ))}
            </div>

            {/* Dekoracyjna scena 3D (tylko desktop): budynek przedszkola <-> rodzice,
                animacja przesyłu danych pomiędzy nimi. Czysto ozdobne, więc ukryte
                przed czytnikami ekranu i niereagujące na wskaźnik. */}
            <div className='login_scene' aria-hidden="true">

                <div className='scene_building'>
                    <div className='scene_building_inner'>
                        <svg viewBox="0 0 220 220">
                            <g fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20,95 100,25 180,95" />
                                <rect x="30" y="95" width="160" height="105" />
                                <rect x="146" y="45" width="16" height="42" />
                                <rect x="90" y="150" width="34" height="50" />
                                <rect x="46" y="118" width="26" height="26" />
                                <rect x="148" y="118" width="26" height="26" />
                                <line x1="100" y1="25" x2="100" y2="6" />
                                <path d="M100 6 L118 12 L100 18 Z" />
                            </g>
                        </svg>
                    </div>
                </div>

                <div className='scene_family'>
                    <div className='scene_family_inner'>
                        <svg viewBox="0 0 160 220">
                            <g fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="118" cy="70" r="13" opacity="0.75" />
                                <path d="M92 150 Q92 100 118 100 Q144 100 144 150" opacity="0.75" />
                                <circle cx="55" cy="42" r="18" />
                                <path d="M20 140 Q20 78 55 78 Q90 78 90 140" />
                            </g>
                        </svg>
                    </div>
                </div>

                {/* Aplikacja mobilna - "pośrednik" pomiędzy przedszkolem a rodzicami */}
                <div className='scene_phone'>
                    <div className='scene_phone_ping'></div>
                    <div className='scene_phone_inner'>
                        <svg viewBox="0 0 100 180">
                            <g fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="10" y="10" width="80" height="160" rx="14" />
                                <line x1="40" y1="22" x2="60" y2="22" />
                                <line x1="38" y1="158" x2="62" y2="158" />
                                <line x1="26" y1="62" x2="74" y2="62" />
                                <line x1="26" y1="84" x2="64" y2="84" />
                                <line x1="26" y1="106" x2="70" y2="106" />
                                <circle cx="78" cy="28" r="9" />
                            </g>
                            <circle cx="78" cy="28" r="3.2" fill="rgba(255,209,102,0.9)">
                                <animate attributeName="opacity" values="1;0.15;1" dur="1.6s" repeatCount="indefinite" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <svg className='scene_data' viewBox="0 0 1000 500" preserveAspectRatio="none">
                    {/* przedszkole -> aplikacja mobilna -> rodzice */}
                    <path id="dataFlowPath" d="M150,250 Q320,150 500,110 Q680,150 850,240" fill="none" stroke="rgba(255,209,102,0.55)" strokeWidth="2.5" strokeDasharray="10 9">
                        <animate attributeName="stroke-dashoffset" values="0;-38" dur="1.1s" repeatCount="indefinite" />
                    </path>
                    {/* rodzice -> aplikacja mobilna -> przedszkole */}
                    <path id="dataReturnPath" d="M840,285 Q680,195 500,155 Q320,195 160,285" fill="none" stroke="rgba(120,224,160,0.45)" strokeWidth="2" strokeDasharray="8 8">
                        <animate attributeName="stroke-dashoffset" values="0;34" dur="1.4s" repeatCount="indefinite" />
                    </path>

                    <circle r="5.5" fill="#ffd166">
                        <animateMotion dur="3.6s" repeatCount="indefinite" begin="0s">
                            <mpath href="#dataFlowPath" />
                        </animateMotion>
                    </circle>
                    <circle r="4.5" fill="#ffd166" opacity="0.85">
                        <animateMotion dur="3.6s" repeatCount="indefinite" begin="1.2s">
                            <mpath href="#dataFlowPath" />
                        </animateMotion>
                    </circle>
                    <circle r="4" fill="#ffd166" opacity="0.7">
                        <animateMotion dur="3.6s" repeatCount="indefinite" begin="2.4s">
                            <mpath href="#dataFlowPath" />
                        </animateMotion>
                    </circle>

                    <circle r="4.5" fill="#78e0a0">
                        <animateMotion dur="4s" repeatCount="indefinite" begin="0.6s">
                            <mpath href="#dataReturnPath" />
                        </animateMotion>
                    </circle>
                    <circle r="4" fill="#78e0a0" opacity="0.8">
                        <animateMotion dur="4s" repeatCount="indefinite" begin="2.6s">
                            <mpath href="#dataReturnPath" />
                        </animateMotion>
                    </circle>
                </svg>

            </div>

            <div
                className={'form_content' + (isTilting ? ' is_tilting' : '')}
                ref={cardRef}
                onMouseMove={onCardMouseMove}
                onMouseLeave={onCardMouseLeave}
                style={{ transform: `perspective(1400px) rotateX(${tilt.rx}deg) rotateY(${tilt.ry}deg)` }}
            >
                <div className='card_shine'></div>

                <div className='logo_wrap'>
                    <img src={logo_poziom} className="img_logo" alt="eLizak.edu.pl" />
                </div>

                {children}
            </div>

            <div className='e_foot_x'>
                {footer}
            </div>
        </div>
    );
}


function LoginForm(props)
{

    var defUser = '';
    var defUserV = false;
    var defPass = '';
    var defPassV = false;


    const [view, setView] = useState('form');

    const btnRef = useRef(0);


    var dU =  sessionStorage.getItem("def_username")+"" ;
    var dP =  sessionStorage.getItem("def_pass")+"";
    var dId =  sessionStorage.getItem("def_place")+"";

    if(dId == null || dId == undefined) dId = -1;



    if(dU != null  && dU != 'null'  && dU != undefined &&  dU.length > 3 )
    {
            defUser = dU;
            defPass = dP;

            defUserV = true;
            defPassV = true;


          //  localStorage.clear();
    }

    //sessionStorage.clear();




    const [req, setReq] = useState(
        {
            username: defUser,
            username_c: defUserV,
            password: defPass,
            password_c: defPassV,
            plDef: dId,
            driver_name: 'PC',
            auth2_code: '',
        }
    );
    const [msg, setMsg] = useState("");


    const [reqBack, setReqBack] = useState(
        {
            email: '',
            phone: '',
        }
    );

    const [reqPass, setReqPass] = useState(
        {
            password: '',
            password2: '',
            code: '',
        }
    );




 const [responseUser, setResponseUser] = useState(null);
 const [auth2Crypt, setAuth2Crypt] = useState('');  //czy wyswietlic ekran autoryacji dwuetapowej


    const [versionStatus, setVersionStatus] = useState(0); // 0 - niesprawdzono, 1- sprawdzam, 2 - sprawdzono


    // Efekt 3D "tilt" karty logowania - aktywny tylko dla urządzeń z myszką (desktop),
    // sterowany przez CSS media query (hover: hover) and (pointer: fine).
    const [tilt, setTilt] = useState({ rx: 0, ry: 0 });
    const [isTilting, setIsTilting] = useState(false);
    const cardRef = useRef(null);

    const handleCardMouseMove = (e) => {

        if(window.matchMedia == undefined || !window.matchMedia('(hover: hover) and (pointer: fine)').matches)
        {
            return;
        }

        var el = cardRef.current;
        if(el == null) return;

        var rect = el.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;

        setIsTilting(true);
        setTilt({
            rx: (0.5 - py) * 14,
            ry: (px - 0.5) * 14,
        });
    }

    const handleCardMouseLeave = () => {
        setIsTilting(false);
        setTilt({ rx: 0, ry: 0 });
    }



    const valChange = (filedName, val, correct, msg) => {
        setReq( {...req,  [filedName]:val, [filedName+"_c"]:correct } );
    }

    const goNext = () => {


        sendData(btnRef);
        //sendData();
    }



    const valChange2 = (filedName, val, correct, msg) => {
        setReqBack( {...reqBack,  [filedName]:val, [filedName+"_c"]:correct } );
    }

    const goNext2 = () => {
      //  sendData();
    }



    const valChange3 = (filedName, val, correct, msg) => {
        setReqPass( {...reqPass,  [filedName]:val, [filedName+"_c"]:correct } );
    }

    const goNext3 = () => {
      //  sendData();
    }



    const showLoginForm = () => {
        setMsg("");
        setView("form");
    }

    const showPassBackForm = () => {
        setMsg("");
        setView("back1");
    }

    const showNewPassForm = () => {
        setMsg("");
        setView("back2");

        setReqPass( {
            password: '',
            password2: '',
            code: '',
        });
    }




    const checkVersion = () => {

                            var dt = {
                                'clock': 1,
                                'version': Config.app_version,
                             }


                            fetch( Config.url + '/rest_v1,check_version_x', {
                                method: 'POST',
                                body: JSON.stringify(dt),
                                headers: {
                                    'Content-Type': 'text/html',
                                    'X-API-KEY': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => {


                                setVersionStatus(2); //gotowe

                                if(res.status != null && res.status != undefined)
                                {

                                        if(res.status == 'OK' || res.status == 'ok' )
                                        {

                                        }


                                        if(res.status == 'VERSION' || res.status == 'version')
                                            {

                                               alert("Nowa wersja panelu zostanie teraz pobrana.");
                                               document.location.reload();
                                            }
                                }

                            } )
                            .catch(err => {
                                console.log("Err " + err);
                            });


   }



   const resetLogin = (e) => {
        setAuth2Crypt('');
        setResponseUser(null);
        setMsg("");
   }


   const sendDataAuth2 = (e) => {


     if(e == null || e == undefined) {
        e = btnRef;
     }

     setMsg("");


       if(req.auth2_code.length < 4)
        {
            setMsg("Podaj prawidłowy kod bezpieczeństwa.");
            return false;
        }



       var defTxt = "...";
       if(e != undefined && e.current != undefined)
       {
         defTxt = e.current.innerHTML;
         e.current.innerHTML = "Czekaj...";
       }

       if(e != undefined && e.target != undefined)
        {
          defTxt = e.target.innerHTML;
          e.target.innerHTML = "Czekaj...";
        }


        var xReq = {
            crypt: auth2Crypt,
            code: req.auth2_code,
        };


         fetch( Config.url + '/rest_v1,go_login_auth2', {
            method: 'POST',
            body: JSON.stringify(xReq),
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {

            if(e != undefined && e.current != undefined)
            {
                  e.current.innerHTML = defTxt;
            }

            if(e != undefined && e.target != undefined)
            {
                   e.target.innerHTML = defTxt;
            }



               if(res.status == 'OK')
               {
                      //zaloguj bez autoryzacji dwuetapowej...
                        props.setUser(
                                    //    responseUser.apiKey,
                            res.param,
                            responseUser.name,
                            responseUser.last_name,
                            responseUser.max_sec,
                            responseUser.type,
                            responseUser.crm_style,
                            responseUser.pl,
                            responseUser.dz,
                            req.plDef, //wybrana placowka
                            -1, //nie wybrano dziecka
                            responseUser, //wszystkie dane
                        );

               }

               if(res.status == 'ERROR')
               {
                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Błędny kod bezpieczeństwa lub kod stracił ważność.');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });



        return false;

   }


    const sendData = (e) => {

        setMsg("");



        if(req.username_c == false)
        {
            setMsg("Podaj prawidłowy adres e-mail.");
            return;
        }

        if(req.password_c == false)
        {
            setMsg("Podaj prawidłowe hasło.");
            return;
        }


       if(e != undefined && e.current != undefined)
       {
        var defTxt = e.current.innerHTML;
         e.current.innerHTML = "Czekaj...";
       }

       if(e != undefined && e.target != undefined)
        {
         var defTxt = e.target.innerHTML;
          e.target.innerHTML = "Czekaj...";
        }




        fetch( Config.url + '/rest_v1,go_login', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {

            if(e != undefined && e.current != undefined)
            {
               e.current.innerHTML = defTxt;
            }

            if(e != undefined && e.target != undefined)
                {
                   e.target.innerHTML = defTxt;
                }

               if(res.status == 'OK')
               {
                    if(res.param.auth_f2 != null && res.param.auth_f2 == 1 )  //wymagana autoryzacja dwuetapowa
                    {
                        setResponseUser(res.param);
                        setAuth2Crypt(res.param.auth_crypt);
                    }
                    else
                    {

                        //zaloguj bez autoryzacji dwuetapowej...
                        props.setUser(
                            res.param.apiKey,
                            res.param.name,
                            res.param.last_name,
                            res.param.max_sec,
                            res.param.type,
                            res.param.crm_style,
                            res.param.pl,
                            res.param.dz,
                            req.plDef, //wybrana placowka
                            -1, //nie wybrano dziecka
                            res.param, //wszystkie dane
                        );

                    }



               }

               if(res.status == 'ERROR')
               {
                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Błędny login lub hasło');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });


         return false;
    }



    const sendCode = (e) => {

        setMsg("");




        if(reqBack.email.length < 10 || reqBack.email_c == false)
        {
            setMsg("Podaj adres e-mail");
            return;
        }

        if(reqBack.phone < 1 || reqBack.phone_c == false)
            {
                setMsg("Podaj numer telefonu");
                return;
            }


        var defTxt = e.target.innerHTML;
        e.target.innerHTML = "Czekaj...";





        fetch( Config.url + '/rest_v1,pass_code', {
            method: 'POST',
            body: JSON.stringify(reqBack),
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {


               e.target.innerHTML = defTxt;

               if(res.status == 'OK')
               {
                        showNewPassForm();
               }

               if(res.status == 'ERROR')
               {
                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Podane dane są nieprawidłowe.');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });


         return false;
    }



    const sendPass = (e) => {

        setMsg("");




        if(reqPass.password.length < 10 || reqPass.password_c == false  )
        {
            setMsg("Podaj nowe hasło wg. wytycznych");
            return;
        }

        if(reqPass.password2 < 10 || reqPass.password2_c == false ||  reqPass.password != reqPass.password2)
            {
                setMsg("Powtórz prawidłowo hasło");
                return;
            }


      //  reqPass["username"]     = reqBack.


        var defTxt = e.target.innerHTML;
        e.target.innerHTML = "Czekaj...";




        reqPass["email"] = reqBack.email;
        reqPass["phone"] = reqBack.phone;


        fetch( Config.url + '/rest_v1,pass_back', {
            method: 'POST',
            body: JSON.stringify(reqPass),
            headers: {
                'Content-Type': 'text/html',
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {


               e.target.innerHTML = defTxt;


               if(res.status == 'OK')
               {
                        showLoginForm();
               }

               if(res.status == 'ERROR')
               {

                    if(res.result == 'BAD.CRYPT.X')
                    {
                        setMsg('Błąd autoryzacji');
                    }else
                    if(res.param == 'BAD')
                    {
                        setMsg('Podane dane są nieprawidłowe.');
                    }else
                    {
                        setMsg(res.parram);
                    }
               }

         } )
         .catch(err => {
            console.log("Err " + err);
         });


         return false;
    }


     function handleSubmit(event){
        event.preventDefault();
    }


    var msgDialog = ( <br></br> )
    if( msg != undefined && msg != null &&  msg.length > 0)
    {
        msgDialog = (
            <div className='msg_error'>{msg}</div>
        )
    }


    if(versionStatus == 0)
    {
        setVersionStatus(1); //sprawdzam
        checkVersion();
    }


    var year = new Date().getFullYear();

    var shellProps = {
        cardRef: cardRef,
        tilt: tilt,
        isTilting: isTilting,
        onCardMouseMove: handleCardMouseMove,
        onCardMouseLeave: handleCardMouseLeave,
    };


    if(view == 'back1')
    {
        return (
            <LoginShell {...shellProps} footer={ <>Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl {year}</> } >

                        {msgDialog}
                        <br/>
                        <form className="form"  onSubmit={handleSubmit} >

                                    <div> Aby ustawić nowe hasło podaj prawidłowy adres e-mail oraz numer telefonu. </div>
                                    <br/>

                                   <div className='filedset_block'>
                                    <InputText  value={reqBack.email} valChange={valChange2} goNext={goNext2} name="email" placeholder={ "Email lub login: "} className='p100' req='1' />

                                    <InputPhone type="password" value={reqBack.phone} valChange={valChange2} goNext={goNext2} name="phone" placeholder={"Telefon: "} className='p100'  req='1' />
                                    </div>
                                <br/>
                                <fieldset>
                                   <span href='' className='btn' onClick={sendCode} ref={btnRef}>Dalej</span>
                                </fieldset>

                        </form>
                        <br/>
                        <br/>
                        <div>
                             <span className='link_normal' onClick={showLoginForm}>wróć do logowania</span>
                        </div>
            </LoginShell>
        )


    }


    if(view == 'back2'  )
        {
            return (
                <LoginShell {...shellProps} footer={ <>Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl {year}</> } >

                            {msgDialog}
                            <br/>
                            <form className="form" onSubmit={handleSubmit}  >

                                       <div>Nowe hasło musi zawierać min. 8 znaków, małe i DUŻE litery, cyfry i znaki specjalne (!@#$...) </div>
                                       <br/>

                                       <div className='filedset_block'>


                                           <InputPassword type="password" value={reqPass.password} valChange={valChange3} goNext={goNext3} name="password" placeholder={"Nowe hasło: "} className='p100'  req='1' />

                                           <InputPassword type="password" value={reqPass.password2} valChange={valChange3} goNext={goNext3} name="password2" placeholder={"Powtórz hasło: "} className='p100'  req='1' />

                                           <InputText type="text" value={reqPass.code} valChange={valChange3} goNext={goNext3} name="code" placeholder={"*Kod SMS: "} className='p100'  req='0' />

                                            <span>*Kod SMS może dotrzeć do Ciebie z opóźnieniem do 1 min. </span>

                                        </div>
                                    <br/>
                                    <fieldset>
                                       <span href='' className='btn' onClick={sendPass} ref={btnRef}>Dalej</span>
                                    </fieldset>

                            </form>
                            <br/>
                            <br/>
                            <div>
                                 <span className='link_normal' onClick={showLoginForm}>wróć do logowania</span>
                            </div>
                </LoginShell>
            )


        }



    var infoX = null;

    if(document.location.href.includes("t=parent"))
    {
        infoX = <div>
                     <div className='small_info'>
                        Aby się zalogować podaj login i hasło. Dane te otrzymałeś lub otrzymałaś od dyrektora placówki drogą elektroniczną lub za pomocą wiadomości sms.
                     </div>

                     <div className='small_info link_bad'>
                         Uwaga, adres e-mail i nr telefonu <u>nie jest loginem</u>. Login otrzymujesz od dyrektora placówki i jest on niezmienny.
                     </div>

                </div>
    }

    if(document.location.href.includes("t=emp"))
        {
            infoX = <div>
                         <div className='small_info'>
                            Aby się zalogować podaj login i hasło. Dane te otrzymałeś lub otrzymałaś od dyrektora placówki drogą elektroniczną lub za pomocą wiadomości sms.
                         </div>

                         <div className='small_info link_bad'>
                             Uwaga, adres e-mail i nr telefonu <u>nie jest loginem</u>. Login otrzymujesz od dyrektora placówki i jest on niezmienny.
                         </div>

                    </div>
        }



    if(auth2Crypt.length > 5  )
    {
                return (
                        <LoginShell {...shellProps} footer={ <>Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl {year}, wersja: <b>{Config.app_version}</b></> } >

                                    {infoX}

                                    {msgDialog}

                                     {
                                        responseUser != null &&
                                        <h3 className="calColor"> <img src={mini_lock}  className="mini_lock" /> {responseUser.name} {responseUser.last_name} </h3>
                                     }


                                     <p>
                                       Właśnie wysłaliśmy do Ciebie <b>sms</b> i <b>e-mail</b> z kodem bezpieczeństwa. <br/> Potwierdź swoją tożsamość podając prawidłowy kod.
                                     </p>
                                    <br/>


                                    <form className="form" onSubmit={handleSubmit}  >

                                            <div className='filedset_block'>
                                                    <InputText  value={req.auth2_code} valChange={valChange} goNext={sendDataAuth2} name="auth2_code" placeholder={ "Kod: "} className='p50' req='1' />
                                                </div>

                                            <fieldset>
                                            <span href='' className='btn'  ref={btnRef} onClick={sendDataAuth2} >Zatwierdź kod</span>
                                            </fieldset>

                                    </form>
                                    <br/>

                                    <div>
                                        <span  className='link_normal' onClick={resetLogin}>wróc do strony logowania</span>
                                    </div>
                        </LoginShell>
                    )
    }



    return (
        <LoginShell {...shellProps} footer={ <>Nowoczesny system zarządzania przedszkolem i żłobkiem, eLizak.edu.pl {year}, wersja: <b>{Config.app_version}</b></> } >

                    {infoX}

                    {msgDialog}


                    <form className="form"  onSubmit={handleSubmit}  >

                               <div className='filedset_block'>
                                      <InputUsername  value={req.username} valChange={valChange} goNext={goNext} name="username" placeholder={props.userData.dic.login + ": "} className='p100' req='1' />

                                      <InputPassword type="password" value={req.password} valChange={valChange} goNext={goNext} name="password" placeholder={props.userData.dic.password + ": "} className='p100'  req='1' />

                                </div>

                            <fieldset>
                               <span href='' className='btn'  ref={btnRef} onClick={sendData} >{props.userData.dic.gologin}</span>
                            </fieldset>

                    </form>
                    <br/>

                    <div>
                         <span  className='link_normal' onClick={showPassBackForm}>{props.userData.dic.forgot_pass}</span>
                         <br/>&nbsp;
                    </div>
        </LoginShell>
    )
}

export default LoginForm;
